import hatsApi from '@/services/hatsApi'

export default {
  getHotels (params) {
    let filter = params || ''
    return hatsApi().get('/master-data/beds/hotels/?filter=' + JSON.stringify(filter))
  },
  book (reservationLine) {
    return hatsApi().put('/operational/reservation_line/beds_book/' + reservationLine.id, reservationLine)
  },
  cancelBooking (reservationLine) {
    return hatsApi().put('/operational/reservation_line/beds_booking_cancel/' + reservationLine.id, reservationLine)
  }
}



// WEBPACK FOOTER //
// ./src/services/hatsApi/Beds.js